﻿import { urlFilterSelector } from 'features/routing';
import { selectLocationContentContext, selectSearchCommandContext } from 'features/searchResultsFacets';
import { selectConstructQueryString } from 'pages/searchResults/redux/selectors';
import HousingProductLocationContentCommand from '../commands/housingProductLocationContentCommand';

/**
 * This function returns a new instance of the HousingProductLocationContentCommand class with specific
 * parameters.
 * @returns A function that creates and returns an instance of the
 * `HousingProductLocationContentCommand` class with three arguments: `selectLocationContentContext`,
 * `urlFilterSelector`, and `selectSearchCommandContext`.
 */
const housingProductLocationContentCommand = () => {
  const command = new HousingProductLocationContentCommand(
    selectLocationContentContext,
    urlFilterSelector,
    selectSearchCommandContext,
    selectConstructQueryString,
  );

  return command;
};

export default housingProductLocationContentCommand;
